import React from 'react';
import EditProfileForm from "../../components/author/edit-profile/edit-profile-form";
import {DetailsWrapper} from "../../components/details-wrapper/details-wrapper";
import {useTranslation} from "react-i18next";

const AuthorEditProfilePage = () => {
    const { t } = useTranslation('author');

    return (
        <DetailsWrapper description={t('editProfile.pageDesc')}>
            <EditProfileForm
                actionAfterSave={null}
            />
        </DetailsWrapper>
    );
}

export default AuthorEditProfilePage;
